<template>
    <div class="order-success-container">
        <div class="order-success-title">订单提交成功，请尽快付款</div>
        <div class="order-success-card">
            <div class="order-success-left">
                <div class="order-success-pay-title">微信支付</div>
                <div class="order-success-desc">
                    <template v-if="!expired">
                        距离二维码过期还有
                        <span class="order-success-countdown">{{ countdown }}</span>秒，过期后请刷新页面重新获取二维码。
                    </template>
                    <template v-else>
                        <span class="order-success-countdown">二维码已过期，请点击下方按钮刷新</span>
                    </template>
                </div>
                <div class="order-success-qrcode">
                    <template v-if="!expired">
                        <img :src="qrcodeUrl" alt="微信支付二维码" />
                    </template>
                    <template v-else>
                        <button @click="refreshQrcode" class="refresh-btn">二维码已过期，点击刷新</button>
                    </template>
                </div>
                <div class="order-success-tip">请使用 <b>微信</b> 扫一扫扫码支付</div>
            </div>
            <div class="order-success-right">
                <img class="order-success-phone" :src="phoneImg" alt="微信扫一扫示意图" />
            </div>
        </div>
    </div>
</template>

<script>
import { generatePayCode, checkOrderPayStatus } from '@/api/sjzx'
export default {
    name: 'OrderSubmitSuccess',
    data() {
        return {
            countdown: 60,
            qrcodeUrl: '', // 二维码图片base64
            timer: null,
            pollTimer: null, // 新增：轮询定时器
            phoneImg: require('@/assets/wechat-phone.png'),
            expired: false, // 新增：二维码是否过期
        };
    },
    mounted() {
        this.startCountdown();
        this.initData();
        this.startPolling(); // 新增：启动轮询
    },
    beforeDestroy() {
        clearInterval(this.timer);
        clearInterval(this.pollTimer); // 新增：清理轮询
    },
    methods: {
        async initData() {

            const params = {
                amount: this.$route.query.totalPrice,
                orderId: this.$route.query.orderId,
                description: 'pc端订单支付',
                orderType: this.$route.query.orderType
            };


            try {
                const res = await generatePayCode(params);
                if (res.code === 0 && res.data) {
                    // 假设后端返回的是纯base64字符串，图片格式为png
                    this.qrcodeUrl = res.data;
                } else {
                    // 处理异常情况
                    this.qrcodeUrl = '';
                }
            } catch (e) {
                // 网络或接口异常
                this.qrcodeUrl = '';
                this.$message && this.$message.error('二维码获取失败，请重试');
            }
        },
        startCountdown() {
            this.timer = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    clearInterval(this.timer);
                    this.expired = true;
                    clearInterval(this.pollTimer);
                }
            }, 1000);
        },
        startPolling() {
            // 每3秒轮询一次
            this.pollTimer = setInterval(async () => {
                try {
                    const res = await checkOrderPayStatus({
                        orderId: this.$route.query.orderId,
                        orderType: this.$route.query.orderType
                    });
                    if (res.code === 0 && res.data === true) {
                        clearInterval(this.pollTimer);
                        this.$message && this.$message.success('支付成功！');
                        // 这里可以跳转到订单列表
                        this.$router.push({ path: '/memberCenter/nzfw/wddd' });
                    }
                } catch (e) {
                    // 可选：处理异常
                    this.$message && this.$message.error('订单状态查询失败，请联系管理员');
                }
            }, 3000);
        },
        async refreshQrcode() {
            this.countdown = 60;
            this.expired = false;
            await this.initData();
            this.startCountdown();
            this.startPolling();
        },
    },
};
</script>

<style scoped>
.order-success-container {
    background: #f7f8fa;
    min-height: 100vh;
    padding: 40px 0;
}

.order-success-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 32px;
    text-align: left;
    margin-left: 80px;
}

.order-success-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    width: 800px;
    margin: 0 auto;
    display: flex;
    padding: 48px 40px;
    align-items: center;
    justify-content: space-between;
}

.order-success-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.order-success-pay-title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 16px;
}

.order-success-desc {
    color: #666;
    margin-bottom: 16px;
}

.order-success-countdown {
    color: #f5222d;
    font-weight: bold;
}

.order-success-qrcode {
    margin: 24px 0 16px 0;
    background: #fff;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.order-success-qrcode img {
    width: 180px;
    height: 180px;
}

.order-success-tip {
    font-size: 16px;
    color: #333;
    margin-top: 8px;
}

.order-success-right {
    margin-left: 40px;
}

.order-success-phone {
    width: 180px;
    height: auto;
}

.refresh-btn {
    width: 180px;
    height: 180px;
    border: 2px dashed #1890ff;
    background: #f0f7ff;
    color: #1890ff;
    font-size: 18px;
    border-radius: 12px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: box-shadow 0.2s, background 0.2s, color 0.2s;
    outline: none;
    position: relative;
}

.refresh-btn:hover {
    background: #e6f7ff;
    color: #096dd9;
    box-shadow: 0 4px 16px rgba(24, 144, 255, 0.15);
    border-color: #40a9ff;
}

.refresh-btn:active {
    background: #bae7ff;
    color: #0050b3;
    border-color: #1890ff;
}

.refresh-btn::before {
    content: "⟳";
    font-size: 36px;
    margin-bottom: 10px;
    display: block;
}
</style>